import { api } from "./client";

export type Ticket = { code: string; status: "issued" | "used" };

/** The caller's ticket for an event (null if they're not going). */
export async function getMyTicket(eventId: string): Promise<Ticket | null> {
  const res = await api<{ ticket: Ticket | null }>(`/api/tickets?event_id=${eventId}`);
  return res.ticket;
}

export type MyTicketListItem = {
  event_id: string;
  title: string;
  starts_at: string;
  format: string | null;
  venue_name: string;
  city: string | null;
  status: "issued" | "used";
};

/** The caller's tickets for upcoming events, soonest first. */
export async function getMyTickets(): Promise<MyTicketListItem[]> {
  const res = await api<{ tickets: MyTicketListItem[] }>("/api/tickets/mine");
  return res.tickets;
}

export type ScanResult =
  | { ok: true; attendee_name: string | null; event_title: string }
  | { ok: false; reason: string };

/** Host scans an attendee QR. Returns a discriminated result instead of
 * throwing so the scanner UI can render each outcome. */
export async function scanTicket(code: string): Promise<ScanResult> {
  try {
    return await api<{ ok: true; attendee_name: string | null; event_title: string }>(
      "/api/tickets/scan",
      { method: "POST", body: JSON.stringify({ code }) },
    );
  } catch (e) {
    const msg = e instanceof Error ? e.message : "";
    const reason = /"error":"([a-z_]+)"/.exec(msg)?.[1] ?? "error";
    return { ok: false, reason };
  }
}
